var _style, _defs, _mask, _path, _defs2, _mask2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 25 21",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 25 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 6,
    y: 0.1,
    width: 18.9,
    height: 15.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0.1,
    width: 18.9,
    height: 15.4,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    className: "st1",
    d: "M6 .1h18.9v15.4H6z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M22.8 10.5v-.2c-.1-2.4-.9-4.5-2.4-6.4C17.8.7 13.2-.7 9.3.6c-1 .3-2 .8-2.9 1.4-.3.3-.5.8-.4 1.3.2.9 1.2 1.2 2 .7 1.8-1.2 3.8-1.7 5.9-1.2 3.2.7 5.3 2.6 6.2 5.8.2.6.3 1.3.3 2h-2.1c1.1 1.7 2.2 3.3 3.3 5 1.1-1.7 2.2-3.3 3.3-5h-2.1z",
    mask: "url(#mask-2_1_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005d9a"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 5.5,
    width: 18.8,
    height: 15.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5.5,
    width: 18.8,
    height: 15.3,
    id: "mask-4_1_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter_1_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3_1_",
    className: "st1",
    d: "M0 5.5h18.8v15.3H0z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M16.8 16.9c-1.1.8-2.3 1.2-3.7 1.3-4 .4-7.7-2.3-8.5-6.3-.1-.5-.1-1-.2-1.5h2.1c-1.1-1.7-2.2-3.3-3.3-5-1.1 1.7-2.2 3.3-3.3 5h2v.3c.1 3 1.3 5.6 3.6 7.6 2.2 1.9 4.8 2.7 7.7 2.4 1.8-.2 3.3-.8 4.8-1.8.6-.4.8-1.2.3-1.8-.1-.5-.9-.6-1.5-.2",
    mask: "url(#mask-4_1_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005d9a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.f3090ea6.svg";
export { ForwardRef as ReactComponent };